import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry"
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry"
import MaintenanceWorkflowForwardingActions from "../../../Sections/ForwardingActions"

const ExecutionEntryCanceled = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingActions />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  )
}

export default ExecutionEntryCanceled
